<template>
  <div class="page" ref="page">
    <!-- <div style="display: flex; justify-content: center; align-items: center; flex-direction: column"></div> -->
    <div class="header-fix">
      <img
        class="fb-icon"
        src="../assets/images/homePc/fb.png"
        alt=""
        @click="goLink('fb', 'click_facebook')"
      />
      <div class="header-right">
        <!-- <img class="fb-icon" src="../assets/images/homePc/fb.png" alt="" @click="goLink('fb', 'click_facebook')" /> -->
        <img
          @click="jumpToPurchase"
          class="stored-icon"
          src="../assets/images/homePc/stored.png"
          alt=""
        />
        <img
          @click="jumpToGL"
          class="gl-icon"
          src="../assets/images/homeH5/gonglue_icon.png"
          alt=""
        />
      </div>
    </div>
    <div class="bg bg-1" ref="bg1">
      <div class="show-content">
        <div class="top-bg"></div>
        <div class="content">
          <!-- <div class="extra-bg" v-if="isMobile">
                <div class="left-bg"></div>
                <div class="right-bg"></div>
              </div> -->
          <div class="content-logo">
            <template>
              <img class="logo" src="../assets/images/logo.png" alt="" />
              <!-- <img
                      class="slogan"
                      src="../assets/images/home_slogan.png"
                      alt=""
                    /> -->
            </template>
          </div>
          <div class="columns">
            <div class="content-left">
              <div class="btn-play btn-play-kf" @click="playVideo">
                <img src="../assets/images/play.jpg" alt="" />
              </div>
              <img
                class="playgame"
                @click="toGameUrl"
                src="../assets/images/homePc/game-stat.png"
              />
              <div class="store">
                <img
                  class="google-play"
                  src="../assets/images/homePc/google-play.png"
                  alt=""
                  @click="goLink('google', 'click_gp_store')"
                />
                <img
                  class="app-store"
                  src="../assets/images/homePc/app-store.png"
                  alt=""
                  @click="goLink('ios', 'click_apple_store')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mask" v-show="isShowVideo">
        <div class="video">
          <div class="close" @click="closeVideo"></div>
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/GYbD6qzBUVY?si=C_LSuYPpDBWJqPIN"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <div class="bg bg-2 bg-7">
      <div class="content">
        <div class="section-second-title">
          <img src="../assets/images/yuyue_txt.png" alt="" />
        </div>
        <div class="section-second-content">
          <div class="section-second-step">
            <div class="second-step-left">
              <div>
                <img
                  class="second-step-img"
                  src="../assets/images/yuyue_step_1.png"
                  alt=""
                />
              </div>
              <div>
                <img
                  style="width: 3rem; height: 2.66rem"
                  src="../assets/images/yuyue_step1_gife.png"
                  alt=""
                />
              </div>
            </div>
            <div class="second-step-right">
              <div>
                <img
                  style="width: 4.79rem; height: 0.76rem"
                  src="../assets/images/yuyue_step1_txt.png"
                  alt=""
                />
              </div>
              <div style="margin-bottom: 0.4rem">
                <img
                  v-if="isAndroid"
                  style="width: 4.01rem; height: 1.19rem"
                  @click="goLink('google', 'click_gp_store')"
                  src="../assets/images/google-play_reserve.png"
                  alt=""
                />
                <img
                  v-else
                  style="width: 3.5rem; height: 1.19rem"
                  @click="goLink('ios', 'click_apple_store')"
                  src="../assets/images/app store_reserve.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div>
            <img
              style="width: 8.75rem; height: 1.02rem"
              src="../assets/images/yuyue_line.png"
              alt=""
            />
          </div>
          <div class="section-second-step">
            <div class="second-step-left">
              <div>
                <img
                  class="second-step-img"
                  src="../assets/images/yuyue_step_2.png"
                  alt=""
                />
              </div>
              <div>
                <img
                  style="width: 3.84rem; height: 4.11rem"
                  src="../assets/images/yuyue_step2_gife.png"
                  alt=""
                />
              </div>
            </div>
            <div class="second-step-right">
              <div>
                <img
                  style="width: 4rem; height: 2.21rem"
                  src="../assets/images/yuyue_step2_txt.png"
                  alt=""
                />
              </div>
              <div>
                <img
                  @click="goLink('fb', 'click_facebook')"
                  style="width: 4.74rem; height: 1.45rem"
                  src="../assets/images/yuyue_FB_button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg bg-3 bg-7">
      <div class="title">
        <img src="../assets/images/sdt_txt.png" alt="" />
      </div>
      <div class="content">
        <div class="swiper-box">
          <swiper
            ref="mySwiper"
            :options="isMobile ? m_swiperOptions : pc_swiperOptions"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in 5"
              :key="index"
            >
              <img
                :src="require(`../assets/images/sdt_${index + 1}.jpg`)"
                alt=""
              />
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="swiper-pagination" slot="pagination" id="custom"></div>
    </div>

    <div class="bg bg-4" ref="bg4" v-if="searchList.length">
      <div class="title">
        <!-- <img class="title-img" src="../assets/images/gonglue_bg.png" alt="" /> -->
      </div>
      <div class="content">
        <div class="section-title">
          <img
            class="title-txt"
            src="../assets/images/homeH5/gonglue_title.png"
            alt=""
          />
        </div>
        <div class="section-search">
          <input
            type="text"
            class="search-input"
            placeholder="請輸入關鍵字搜索"
            v-model="keyword"
          />
          <div class="search-btn" @click="search()">搜索</div>
        </div>
        <div class="section-list" v-if="!isShow">
          <div class="banner">
            <img
              class="banner-img"
              src="../assets/images/homeH5/banner.jpg"
              alt=""
            />
          </div>
          <ul class="section-list-item">
            <li v-for="(item, index) in searchList" :key="index">
              <div
                v-if="showSubList[index] && showSubList[index].length === 0"
                class="item"
                :style="{
                  backgroundImage: `url(${item.bg_img})`
                }"
                @click="toggleSubList(index)"
              >
                <div class="item-title">
                  {{ item.name }}
                </div>
                <div>
                  <img
                    class="item-img"
                    :src="require(`../assets/images/homeH5/down.png`)"
                    alt=""
                  />
                </div>
              </div>
              <ul
                v-if="showSubList[index] && showSubList[index].length"
                class="section-list-detail"
              >
                <div class="sub-item" @click="toggleSubList(index)">
                  <div class="sub-item-title">
                    {{ item.name }}
                  </div>
                  <div>
                    <img
                      class="sub-item-img"
                      :src="require(`../assets/images/homeH5/up.png`)"
                      alt=""
                    />
                  </div>
                </div>

                <li
                  v-for="(subItem, subIndex) in showSubList[index]"
                  :key="subIndex"
                >
                  <div class="sub-item-li" @click="goArticle(subItem)">
                    <div>
                      {{ subItem.title }}
                    </div>
                    <div>
                      {{ formatDate(subItem.created_ts) }}
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-else class="search-list">
          <ul v-if="searchTitle.length">
            <li v-for="(subItem, subIndex) in searchTitle" :key="subIndex">
              <div class="sub-item-li item" @click="goArticle(subItem)">
                <div>
                  {{ subItem.title }}
                </div>
                <div>
                  {{ formatDate(subItem.created_ts) }}
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="no-data">暫無數據</div>
        </div>
      </div>
      <div class="footer">
        <div style="display: flex; align-items: center">
          <div style="display: flex; align-items: center">
            <img class="icon1" src="../assets/images/flame.jpg" alt="" />
            <img class="icon2" src="../assets/images/Insane.jpg" alt="" />
          </div>

          <div class="gongsi">
            共和國科技有限公司<br />
            COPYRIGHT © 2012-2024 ALL RIGHTS RESERVED<br />
            聯繫我們: cs_as@flame-games.com
          </div>
        </div>
        <div style="display: flex">
          <img class="icon3" src="../assets/images/12+.jpg" alt="" />
          <div class="tips">
            ※本遊戲部分內容涉及性、遊戲角色穿著凸顯性特徵之服飾或裝扮，但不涉及性暗示。<br />
            ※本遊戲部分內容涉及暴力、打鬥、攻擊等未達血腥之畫面或有輕微恐怖之畫面。<br />
            ※本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力進行適度消費。<br />
            ※請注意遊戲時間，避免沉迷，長時間進行遊戲，容易影響作息，宜適度休息及運動。
          </div>
        </div>
      </div>
    </div>
    <Dialog
      v-if="isShowDialog"
      :visible="isShowDialog"
      :text_index="text_index"
      :confirm="confirm"
      @close="isShowDialog = false"
    ></Dialog>
    <Menu
      :visible="isShowMenu"
      :index="active_index"
      @go="goPage"
      @close="isShowMenu = false"
    ></Menu>
    <!-- <Matters :visible="isShowRotateMatters" @close="isShowRotateMatters = false"></Matters> -->
  </div>
</template>

<script>
const events = [
  'click_reservation', // 立即事前预约
  'pre_reg_success', // 立即预约
  'click_fanpage', // lounge
  'click_youtube', // youtube
  'click_gp_store', // google play
  'click_apple_store', // appstore
  'click_one_store', // onestore
  'click_galaxy_store', // galaxystore
  'join_fanpage', // 立即前往lounge
  'goto_one_store' // 立即前往onestore
]
import Select from '../components/Select.vue'
import Dialog from '../components/Dialog.vue'
import Menu from './Menu.vue'
import {
  summitSubscribe,
  event,
  getArticles,
  getModules
} from '../global/api/api'
import { analysis } from '../global/js/analysis'
import { areaNumOptions } from './enums'
import { formatTime } from '../global/js/utils'
export default {
  name: 'HomeH5',
  components: {
    Dialog,
    Menu,
    Select
  },
  data() {
    return {
      navs: [
        {
          off: require('../assets/images/mobile_home.png'),
          on: require('../assets/images/on_mobile_home.png')
        },
        {
          off: require('../assets/images/mobile_booking.png'),
          on: require('../assets/images/on_mobile_booking.png')
        },
        {
          off: require('../assets/images/mobile_gift.png'),
          on: require('../assets/images/on_mobile_gift.png')
        },
        {
          off: require('../assets/images/mobile_games.png'),
          on: require('../assets/images/on_mobile_games.png')
        }
      ],
      checkContract: false,
      areaNum: '+886',
      areaNumOptions: Object.freeze(areaNumOptions),
      role_list: ['guang', 'an', 'shui', 'huo', 'tu', 'feng'],
      // lotteryPhone: '', // 中奖手机号
      // isSubscribe: false, // 是否预约
      // lottery_time: 0, // 剩余抽奖次数
      isShowSubNav: false, // 是否显示子菜单
      isMobile: true, // 是否是移动端
      isShowMenu: false, // 是否显示移动端菜单
      isShowVideo: false, // 是否显示视频bo
      isShowDialog: false, // 是否显示弹窗
      // isShowRotateMatters: false, // 是否显示注意事项
      text_index: 1, // 弹窗文本下标
      confirm: false, // 弹窗是否有footer
      // isShowHeader: true, // 顶部导航显示
      // isUpSideNav: false, // 侧边store上移
      active_index: 0,
      active_role_index: '',
      link_list: {
        game: 'https://chubby3kd.onelink.me/gZzU/officalwebsite',
        fb: 'https://www.facebook.com/Chubby3KD',
        discord: 'https://discord.gg/YMpsA4VAhW',
        lounge: 'https://game.naver.com/lounge/Girls_Evolution/home',
        ytbe: 'https://www.youtube.com/channel/UCIXZ1lEPWwvFeS2-HhJU6AQ',
        ios: 'https://apps.apple.com/tw/app/id6502481057',
        google:
          'https://play.google.com/store/apps/details?id=com.hookylin.tw.qqsg.gp',
        onestore: 'https://onesto.re/OA00769206',
        galaxy:
          'https://galaxystore.samsung.com/detail/com.hookylin.tw.sftx.galaxystore',

        detail: 'https://op-static.hookylin.com/user-privacy.html',
        footer: 'https://op-static.hookylin.com/user-privacy.html'
      },
      options: {
        // autoScrolling: false,
        // section配置
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        //是否显示导航，默认为false
        // navigation: true,
        //为每个section设置背景色
        sectionsColor: [
          '#000',
          '#000',
          '#000',
          '#000',
          '#000',
          '#000',
          '#000',
          '#000'
        ],
        // 控制动画出现
        onLeave: (index, nextIndex, direction) => {
          this.active_index = nextIndex.index
          if (this.active_index === 1) {
            this.active_role_index = 0
          } else {
            this.active_role_index = ''
          }
          // 动画效果js
          // if (this.active_index !== 0) {
          //   this.isShowHeader = false
          //   this.isUpSideNav = true
          // } else {
          //   this.isShowHeader = true
          //   this.isUpSideNav = false
          // }
        }
      },
      // 轮播图配置
      pc_swiperOptions: {
        autoplay: {
          delay: 3000, //滚动时间间隔
          disableOnInteraction: false //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1,
        centeredSlides: true,
        // spaceBetween: '-20%',
        // spaceBetween: 10,
        // history: 'love',
        // 设置点击箭头
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            let _html = ''
            for (let i = 1; i <= total; i++) {
              if (current == i) {
                _html += `<div class="swiper-pagination-custom-item swiper-pagination-bullet">
                  <div class="custom active-custom" index="${i}">
                    <img class="custom-img" src="${require(`../assets/images/button_s${i}.jpg`)}" index="${i}" alt="">
                  </div>
                </div>`
              } else {
                _html += `<div class="swiper-pagination-custom-item swiper-pagination-bullet" tabindex="${i}" aria-label="Go to slide ${i}">
                  <div class="custom" index="${i}">
                    <img class="custom-img" src="${require(`../assets/images/button_0.jpg`)}" index="${i}" alt="">
                  </div>
                </div>`
              }
            }
            return _html
          }
        }
      },
      m_swiperOptions: {
        autoplay: {
          delay: 3500, //滚动时间间隔
          disableOnInteraction: false //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        slidesPerView: 1,
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            let _html = ''
            for (let i = 1; i <= total; i++) {
              if (current == i) {
                _html += `<div class="swiper-pagination-custom-item swiper-pagination-bullet">
                  <div class="custom active-custom" index="${i}">
                    <div style="border-radius: 50%;height:0.33rem;width:0.33rem;background-color: #9C640A;"></div>
                  </div>
                </div>`
              } else {
                _html += `<div class="swiper-pagination-custom-item swiper-pagination-bullet" tabindex="${i}" aria-label="Go to slide ${i}">
                  <div class="custom" index="${i}">
                    <div style="border-radius: 50%;height:0.33rem;width:0.33rem;background-color: #C0AC95;"></div>
                  </div>
                </div>`
              }
            }
            return _html
          }
        }
      },
      deviceList: [],
      params: {
        os: 'android',
        game_id: 2, // 进化纪元id
        mobile: ''
      },
      // lotteryParams: {
      //   game_id: 1, // 青云传
      //   mobile: ''
      // },
      tip: {
        1: true,
        2: true,
        3: true
      },
      isAndroid: navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/),
      randomCount: '',
      scrollTop: '',
      searchInput: '',
      searchList: [],
      showListDetail: false,
      preIndex: -1,
      moduleId: -1,
      keyword: null,
      showSubList: [],
      formatDate: formatTime,
      searchTitle: [],
      isShow: false
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  created() {
    this.reserveEvent('page_view')
    this.isMobilePlat()
    console.log(document.body.style)
    // window.addEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    // window.addEventListener('pagehide', (e) => this.pagehideFn(e))
  },
  mounted() {
    this.incrementRandomNumber()
    this.getModuleList()
    //window.addEventListener('scroll', this.scrollTop)
  },
  destroyed() {
    // window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    // window.removeEventListener('pagehide', (e) => this.pagehideFn(e))
  },
  methods: {
    getModuleList() {
      getModules({ game_id: 2 }).then((res) => {
        if (res.code == 0) {
          this.searchList.push(...res.data)
          this.searchList.map((item) => {
            this.showSubList.push([])
          })
          console.log('this.searchList', this.searchList)
        }
      })
    },
    toGameUrl() {
      window.open(this.link_list['game'], '_blank')
    },
    /**判断是否是移动端 */
    isMobilePlat() {
      const width = document.body.clientWidth
      if (width <= 768) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
      console.log('this.isMobile', this.isMobile)
    },
    jumpToPurchase() {
      this.$router.push({
        path: '/purchase'
      })
    },
    jumpToGL() {
      this.scrollTop = this.$refs.bg4.clientHeight
      document.documentElement.scrollTop = this.scrollTop + 600
    },
    /**移动端显示菜单 */
    showMenu() {
      this.isShowMenu = !this.isShowMenu
    },
    /**菜单跳转页面 */
    goPage(index) {
      this.active_index = index
      this.scrollTop = this.$refs.bg1.clientHeight
      document.documentElement.scrollTop = this.scrollTop - 30
      if (index == 1) {
        this.reserveEvent('click_reservation')
      }
    },
    /**显示子菜单 */
    showSideNav() {
      this.isShowSubNav = true
    },
    /**视频播放与关闭 */
    playVideo() {
      this.isShowVideo = true
    },
    closeVideo() {
      this.isShowVideo = false
    },
    goReserve() {
      this.goPage(1)
      this.reserveEvent('click_reservation')
    },
    /**第一个协议被勾中 */
    tipCheckChange() {
      if (this.tip[1]) {
        this.tip[2] = true
        this.tip[3] = true
      }
    },
    /**提交预约信息 */
    async subscribe() {
      // 未勾选必选项目
      if (!this.tip[1] || !this.tip[2] || !this.tip[3]) {
        this.setDialogParams(2)
        return
      }
      // 手机号格式不正确
      if (!this.params.mobile) {
        this.setDialogParams(1)
        return
      }
      const params = JSON.parse(JSON.stringify(this.params))
      params.mobile = '82010' + params.mobile
      console.log('params', params)
      const res = await summitSubscribe(params).catch((err) => {
        // 手机号格式不正确
        if (err.code === 40001) {
          this.setDialogParams(1)
          return
        }
      })
      if (res.code === 0) {
        if (res.data.is_new) {
          // 恭喜您预约成功
          this.setDialogParams(0)
          this.reserveEvent('pre_reg_success')
          return
        } else {
          // 该手机号已预约，不可重复预约
          this.setDialogParams(3)
          return
        }
      } else {
        console.log(res.msg)
      }
    },
    /**设置弹窗参数 */
    setDialogParams(text_index) {
      this.text_index = text_index
      this.isShowDialog = true
    },
    /**跳转链接 */
    goLink(key, event_name) {
      if (event_name) {
        this.reserveEvent(event_name)
      }
      if (key === 'google') {
        analysis(0)
      } else if (key === 'ios') {
        analysis(1)
      }
      window.open(this.link_list[key], '_blank')
    },
    // 埋点事件
    reserveEvent(event_name) {
      const params = {
        game_id: 2,
        source: this.$route.query.from,
        event_name
      }
      event(params)
    },
    /**角色切换 */
    changeRole(index) {
      this.active_role_index = index
    },
    // 播放角色音频
    playAudio(name) {
      const ref = name + 'audioPlayer'
      this.$refs[ref][0].play()
    },
    /* 前一步 */
    clickPrev() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn <= 0 || length == 0) {
        return false
      }
    },
    /* 后一步 */
    clickNext() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn >= length - 1 || length == 0) {
        return false
      }
    },
    incrementRandomNumber() {
      const today = new Date()
      const targetDate = new Date(today.getFullYear(), 5, 15)

      // 检查今天是否在 6 月 15 日之前并且递增随机数是否小于 50,000
      if (today < targetDate && this.getRandomNumberFromStorage() < 50000) {
        const randomNumber = this.getRandomNumberFromStorage() || 0
        const increment = Math.floor(Math.random() * 100) + 1 // 随机数字在 1 到 100 之间
        const newRandomNumber = randomNumber + increment

        this.setRandomNumberToStorage(newRandomNumber)
        console.log(
          `Incremented random number by ${increment}. New value: ${newRandomNumber}`
        )
      } else {
        console.log('Stopped incrementing random number.')
      }
    },
    getRandomNumberFromStorage() {
      return parseInt(localStorage.getItem('randomNumber'), 10) || 0
    },
    setRandomNumberToStorage(randomNumber) {
      localStorage.setItem('randomNumber', randomNumber.toString())
      this.randomCount = randomNumber.toString()
    },
    toggleSubList(index) {
      console.log('index', index, this.preIndex, this.showSubList)
      if (this.preIndex === index && this.showSubList[index].length > 0) {
        this.$set(this.showSubList, index, [])
      } else {
        if (this.preIndex >= 0) {
          this.showSubList[this.preIndex] = []
        }
        this.moduleId = this.searchList[index].id
        this.getArticleList(index)
      }
      this.preIndex = index
    },
    getArticleList(index) {
      let params = {
        game_id: 2
      }
      if (this.moduleId > 0) {
        params.module_id = this.moduleId
      }
      if (this.keyword) {
        params.title = this.keyword
      }
      getArticles(params).then((res) => {
        if (res.code === 0) {
          if (index >= 0) {
            this.$set(this.showSubList, index, res.data.list)
          } else {
            this.isShow = true
            this.searchTitle = res.data.list
          }
        }
      })
    },
    goArticle(item) {
      this.$router.push({
        path: '/article',
        query: {
          id: item.id
        }
      })
    },
    search() {
      this.getArticleList()
    }
  },
  watch: {
    keyword: function (val) {
      if (!val) {
        this.isShow = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/keyframes.less';
.page {
  position: relative;
  width: 100vw;
  height: 100vh;
}
/* PC端 */
// @media screen and (min-width: 769px) {
//   @import '../assets/css/pc.less';
// }

/* 移动端  */
// @media screen and (max-width: 769px) {
//   // @import '../assets/css/m.less';
//   @import '../assets/css/home_h5.less';
// }
@import '../assets/css/home_h5.less';
</style>
